import * as React from 'react';
import { ComponentProps, FlexValidation, ValidationProps } from 'ui';
import styles from './flex-row-panel.scss';

export interface FlexRowPanelProps extends ComponentProps {
  children: any;
  validation?: ValidationProps;
}

export const FlexRowPanel: React.FC<FlexRowPanelProps> = (props: FlexRowPanelProps) => {

  const {
    componentId,
    children,
    validation
  } = props;

  return (React.Children.count(children) ?
    <div id={componentId} className={`row flex-row-panel ${styles.panel}`}>
      <FlexValidation {...validation}/>
      {children}
    </div> :
    <div className={styles.withoutChildren}/>
  );
};
